<template>
  <v-card>
    <v-card-title class="toolbar">
      <h3 class="mr-3">
        Orders ({{ bOrders.length }}/{{ bOrdersPagination.total }})
      </h3>
      <h5 class="mr-3">
        OPEN (<a class="countLabel"> {{ ordersCount.OPEN }} </a>)
      </h5>
      <h5 class="mr-3">
        QUEUED (<a class="countLabel"> {{ ordersCount.QUEUED }} </a>)
      </h5>
      <h5 class="mr-3">
        PENDING (<a class="countLabel"> {{ ordersCount.PENDING }} </a>)
      </h5>
      <h5 class="mr-3">
        DELIVERED (<a class="countLabel"> {{ ordersCount.DELIVERED }} </a>)
      </h5>
      <h5 class="mr-3">
        ERROR (<a class="countLabel"> {{ ordersCount.ERROR }} </a>)
      </h5>
      <v-spacer />
      <div
        v-if="selected.length > 0"
        class="ml-3"
      >
        <v-tooltip
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              flat
              icon
              @click="editModalOpen = true"
              v-on="on"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </div>
      <div
        v-if="bOrders.length > 0"
        class="ml-3"
      >
        <v-tooltip
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              flat
              icon
              @click="openProcessOrders"
              v-on="on"
            >
              <v-icon>swap_vert</v-icon>
            </v-btn>
          </template>
          <span>Process orders</span>
        </v-tooltip>
        <v-tooltip
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              flat
              icon
              @click="downloadModalOpen = true"
              v-on="on"
            >
              <v-icon>archive</v-icon>
            </v-btn>
          </template>
          <span>Download CSV</span>
        </v-tooltip>
      </div>
      <v-tooltip
        top
        dark
      >
        <template v-slot:activator="{ on }">
          <v-btn
            dark
            flat
            icon
            @click="onChangePagination"
            v-on="on"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </template>
        <span>Refresh orders</span>
      </v-tooltip>
    </v-card-title>

    <v-card-title class="filters grey lighten-5">
      <v-select
        v-model="selectedStatus"
        class="ml-3"
        flat
        hide-details
        small
        clearable
        :items="statuses"
        item-text="title"
        item-value="status"
        label="Search by status"
        prepend-icon="pending_actions"
        @change="onChangeColumnValueList"
      />

      <v-text-field
        v-model="search"
        class="ml-3"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      />
    </v-card-title>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="bOrders"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :total-items.sync="bOrdersPagination.total"
      select-all
      item-key="id"
      class="elevation-1"
      @update:pagination="updatePagination"
    >
      <template
        slot="headers"
        slot-scope="props"
      >
        <tr>
          <th>
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              color="primary"
              hide-details
              @click.native="toggleAll"
            />
          </th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : ''
            ]"
            @click="changeSort(header.value)"
          >
            <v-icon small>
              arrow_upward
            </v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template
        slot="items"
        slot-scope="props"
      >
        <tr
          :active="props.selected"
          @click="props.selected = !props.selected"
        >
          <td>
            <v-checkbox
              :input-value="props.selected"
              color="regular"
              hide-details
            />
          </td>
          <td class="text-xs-center">
            {{ props.item.id }}
          </td>
          <td class="text-xs-center">
            {{ props.item.ext_order_id }}
          </td>
          <td class="text-xs-center">
            {{ props.item.ext_user_id }}
          </td>
          <td class="text-xs-center">
            <v-chip
              :color="getStatus(props.item.status).color"
              outline
              small
            >
              {{ getStatus(props.item.status).title }}
            </v-chip>
          </td>
          <td class="text-xs-center">
            {{ props.item.target_address }}
          </td>
          <td class="text-xs-center">
            {{ props.item.blockchain_asset_id }}
          </td>
          <td class="text-xs-center">
            {{ props.item.amount }}
          </td>
          <td class="text-xs-center">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="grey"
                  outline
                  small
                  v-on="on"
                >
                  <span>
                    {{ formatDateSmall(props.item.created_at) }}
                  </span>
                </v-chip>
              </template>
              {{ formatDate(props.item.created_at) }}
            </v-tooltip>
          </td>
        </tr>
        <tr v-if="props.item.error">
          <td
            colspan="9"
            class="text-xs-left errorTd"
          >
            <div class="errorRow">
              <v-icon color="red">
                info
              </v-icon> {{ props.item.error }}
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog
      v-model="processOrdersModalOpen"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title
          class=" grey lighten-2"
        >
          {{
            selected.length > 0 ? `Process ( ${selected.length} ) orders?` :
            `Process ( ${selectedStatus ?
              ordersCount[selectedStatus] : ordersCount.TOTAL} ) ${selectedStatus ?
              selectedStatus : ''} orders?`
          }}
          <h5>
            Warning: Please make sure you want to proceed.
            Vault transaction status can be checked here:
            <a
              style="color: blue"
              target="_blank"
              href="/#/vault/transactions"
            >Search</a>
          </h5>
        </v-card-title>

        <v-form
          ref="processOrderForm"
          @submit.prevent="processSelectedOrders"
        >
          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="processOrdersModalOpen = false"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              color="blue"
              text="Process"
              :loading="loading"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editModalOpen"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Edit Selected Orders
        </v-card-title>
        <v-form
          ref="orderForm"
          @submit.prevent="bulkUpdate"
        >
          <v-card-text>
            <v-select
              v-model="selectedStatus"
              :items="statuses"
              item-text="title"
              item-value="status"
              label="Status"
            />
          </v-card-text>
          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="editModalOpen = false"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              color="blue"
              text="Bulk Update"
              :loading="loading"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="downloadModalOpen"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Download Orders CSV file
        </v-card-title>
        <v-form
          ref="downloadForm"
          @submit.prevent="downloadCSVFile"
        >
          <v-card-text>
            <v-layout>
              <v-flex xs6>
                <v-menu
                  v-model="pickerStartDateOpen"
                  :close-on-content-click="false"
                  full-width
                  max-width="290"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="downloadStartDate"
                      label="From"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="downloadStartDate"
                    :max="todaysDate"
                    show-current
                    color="info"
                    @change="pickerStartDateOpen = false"
                  />
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-menu
                  v-model="pickerEndDateOpen"
                  :close-on-content-click="false"
                  full-width
                  max-width="290"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="downloadEndDate"
                      label="To"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="downloadEndDate"
                    :max="todaysDate"
                    show-current
                    color="info"
                    @change="pickerEndDateOpen = false"
                  />
                </v-menu>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="downloadModalOpen = false"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              color="blue"
              text="Download CSV"
              :loading="loading"
              :disabled="!(downloadEndDate && downloadStartDate)"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Button } from '@/components/shared';
import { downloadCsvFile, json2csv, setQuery, toQueryString } from '@/helpers';
import BlockchainOrderStatus from '@/enum/blockchainOrders/BlockchainOrderStatus';

export default {
  name: 'BlockchainOrdersTable',
  components: {
    'e-button': Button,
  },
  props: {
    bOrders: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    putBOrder: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      downloadModalOpen: false,
      editModalOpen: false,
      processOrdersModalOpen: false,
      isLoadTableData: false,
      pickerStartDateOpen: false,
      pickerEndDateOpen: false,
      downloadStartDate: '',
      downloadEndDate: new Date().toISOString().substr(0, 10),
      todaysDate: new Date().toISOString().substr(0, 10),

      ordersCount: {
        OPEN: 0,
        PENDING: 0,
        QUEUED: 0,
        DELIVERED: 0,
        ERROR: 0,
      },
      selectedStatus: '',
      search: '',
      selected: [],
      pagination: {
        page: 1,
        rowsPerPage: 25,
        sortBy: 'created_at',
        descending: true,
      },
      rowsPerPageItems: [
        {
          text: '5',
          value: 5,
        },
        {
          text: '10',
          value: 10,
        },
        {
          text: '25',
          value: 25,
        },
        {
          text: '50',
          value: 50,
        },
        {
          text: '100',
          value: 100,
        },
        {
          text: 'All',
          value: -1,
        },
      ],
      filters: {
        created_at: [],
        status: [],
      },
      headers: [
        {
          text: 'Id',
          align: 'left',
          sortable: true,
          value: 'id',
        },
        {
          text: 'Order Id',
          align: 'left',
          sortable: true,
          value: 'ext_order_id',
        },
        {
          text: 'User Id',
          align: 'left',
          sortable: true,
          value: 'ext_user_id',
        },
        {
          text: 'Status',
          value: 'status',
          filter: {
            value: true,
            type: 'select',
          },
        },
        {
          text: 'Target Address',
          value: 'target_address',
          sortable: true,
        },
        {
          text: 'Blockchain Asset Id',
          value: 'blockchain_asset_id',
          sortable: true,
        },
        {
          text: 'Amount',
          value: 'amount',
          sortable: true,
        },
        {
          text: 'Created At',
          value: 'created_at',
        },

      ],
    };
  },
  computed: {
    ...mapState({
      bOrdersPagination: state => state.blockchainOrderStore.bOrdersPagination,
    }),
    statuses() {
      const status = Object.keys(BlockchainOrderStatus)
        .map(item => BlockchainOrderStatus[item]);

      return status;
    },
  },
  watch: {
    async bOrders() {
      this.getDefaultFilters();
      await this.$nextTick();
      await this.changePage();

      this.updateOrdersCount();
    },
    loading(val, oldVal) {
      if (!val && oldVal) {
        this.editModalOpen = false;
      }
    },
    search(val) {
      setQuery(
        {
          search: val,
        },
        this.$route,
        this.$router,
      );
      this.onChangePagination();
    },
  },
  methods: {
    ...mapActions(['getBOrders', 'getAllBOrders', 'processOrders']),
    formatDate(date) {
      return this.$moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    formatDateSmall(date) {
      return this.$moment(date).format('DD/MM/YYYY');
    },
    getStatus(status) {
      return this.statuses.find(item => item.status === status) || {};
    },
    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.bOrders.slice();
      }
    },
    onChangePagination() {
      const query = toQueryString({
        per_page: this.pagination.rowsPerPage,
        page: this.pagination.page,
        search: this.search,
        sort: `${this.pagination.sortBy}:${this.pagination.descending ? 'desc' : 'asc'}`,
      });
      if (typeof window.LIT !== 'undefined') {
        clearTimeout(window.LIT);
      }
      window.LIT = setTimeout(() => {
        this.getBOrders(query);
      }, 1000);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
      this.onChangePagination();
    },
    onChangeColumnValueList(value) {
      this.search = value || '';
    },
    getDefaultFilters() {
      if (this.$route.query) {
        Object.keys(this.$route.query).forEach((item) => {
          let value = this.$route.query[item];

          if (Object.prototype.hasOwnProperty.call(this.filters, item)) {
            if (typeof this.filters[item] === 'string') {
              this.filters[item] = value;
            } else if (String(this.$route.query[item]).includes(';')) {
              value = this.$route.query[item].split(';');
              this.filters[item] = value;
            } else {
              this.filters[item].push(value);
            }
          }
        });
      }
    },
    bulkUpdate() {
      const data = this.selected.map(v => ({
        ext_order_id: v.ext_order_id,
        status: this.selectedStatus,
      }));

      this.putBOrder(
        {
          data,
        },
        true,
      );
    },
    updateOrdersCount() {
      this.ordersCount = {
        OPEN: 0,
        PENDING: 0,
        QUEUED: 0,
        DELIVERED: 0,
        ERROR: 0,
        TOTAL: 0,
      };

      this.bOrders.map((order) => {
        this.ordersCount[order.status] += 1;
        this.ordersCount.TOTAL += 1;

        return order;
      });
    },

    async downloadCSVFile() {
      const headers = this.headers.map(v => ({
        name: v.value,
        value: v.value,
      }));

      const params = {
        search: this.search,
        'properties.created_at': [`${this.downloadStartDate}:${this.downloadEndDate}`],
        sort: `${this.pagination.sortBy}:${this.pagination.descending ? 'desc' : 'asc'}`,
      };

      const bOrders = await this.getAllBOrders(params);
      const data = json2csv(bOrders, headers);

      await downloadCsvFile(data, `Blockchain_Orders_${Date.now()}.csv`);

      this.downloadModalOpen = false;
    },

    updatePagination(pagination) {
      if (this.isLoadTableData) {
        setQuery(
          {
            page: pagination.page,
          },
          this.$route,
          this.$router,
        );
      }
      this.onChangePagination();
    },
    async changePage() {
      const { page, search } = this.$route.query;
      this.search = search;
      await this.$nextTick();
      this.isLoadTableData = true;
      this.pagination.page = page ? Number(page) : 1;
    },
    async openProcessOrders() {
      this.processOrdersModalOpen = true;
    },
    async processSelectedOrders() {
      const data = {
        extOrderIds: [],
      };
      let items = [];
      if (this.selected.length > 0) {
        items = this.selected;
      } else {
        items = this.bOrders;
      }
      data.extOrderIds = items.map(
        v => (this.selected.length > 0 ? v.ext_order_id :
          (v.status.toLowerCase() === 'open' || v.status.toLowerCase() === 'error') ? v.ext_order_id : false),
      )
        .filter(v => v !== false && v !== '');
      await this.processOrders(
        {
          data,
        },
      );

      this.processOrdersModalOpen = false;
      this.onChangePagination();
    },
  },
};
</script>

<style lang="scss" scoped>
.errorRow {
  width: 98%;
  position: absolute;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  float: left;
}

.errorTd {
  padding-bottom: 32px !important;
  .v-icon {
    vertical-align: middle;
  }
}

a {
  text-decoration: none;
  color: black;
}

.toolbar {
  background-color: #1a4c7d;
  color: white;
}

.infoLabel {
  margin-left: 16px;
}

.countLabel {
  color: #fff;
}
table.v-table tbody td,
.v-datatable thead th {
    padding: 0 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/blockchainOrders/BlockchainOrdersTable.vue